import { useViewModel as sharedViewModel } from './shared';

export const useViewModel = (props) => {
    const shared = sharedViewModel(props);

    return {
        ...shared,
    };
};
export default useViewModel;
